import React, { useState } from 'react';
import Video from 'twilio-video';
import { Container, Typography, Paper, Grid, Button, Snackbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    marginTop: '2.5em',
  },
  paper: {
    padding: '1.5em',
    textAlign: 'center',
  },
  heading: {
    marginBottom: '0.6em',
  },
  button: {
    marginTop: '1em',
  },
});

export default function UnsupportedBrowserWarning({ children }: { children: React.ReactElement }) {
  const classes = useStyles();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setSnackbarOpen(true);
    });
  };

  const handleClose = () => {
    setSnackbarOpen(false);
  };

  if (!Video.isSupported) {
    return (
      <Container>
        <Grid container justifyContent="center" className={classes.container}>
          <Grid item xs={12} sm={8} md={6}>
            <Paper className={classes.paper}>
              <Typography variant="h4" className={classes.heading}>
                Unsupported Browser
              </Typography>
              <Typography variant="body1" paragraph>
                Your phone is currently set to use an unsupported browser.
              </Typography>
              <Typography variant="body1" paragraph>
                To enable video access, please copy the URL from this page and open it in a supported browser like
                <strong> Chrome, Safari, or Firefox</strong>.
              </Typography>
              <Button variant="contained" color="primary" onClick={copyLink} className={classes.button}>
                Copy Link to Page
              </Button>
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleClose}
                message="Link copied to clipboard!"
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  }

  return children;
}
